'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextFieldRowStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  disabled: _propTypes2.default.bool,
  /**
   * Full-width TextArea doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * If textfield is dense it has smaller paddings
   */
  dense: _propTypes2.default.bool,
  /**
   * If bordered = false, TextArea will have only bottom border
   */
  bordered: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
  /**
   * If slidingLabel = true, label will float to top
   * when parent textfield is focused or filled
   */
  slidingLabel: _propTypes2.default.bool,
  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  disabled: false,
  fullWidth: false,
  dense: false,
  bordered: false,
  colorScheme: 'neutral',
  slidingLabel: false
};

/** PROP RECEIVERS */
var size = function size(_ref) {
  var dense = _ref.dense,
      fullWidth = _ref.fullWidth,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = null;

  if (dense && !fullWidth) {
    source = theme.reactackle.components.textfield.textfield.size.dense;
  } else if (dense && fullWidth) {
    source = theme.reactackle.components.textfield.textfield.size.denseFullWidth;
  } else if (!dense && fullWidth) {
    source = theme.reactackle.components.textfield.textfield.size.fullWidth;
  } else {
    source = theme.reactackle.components.textfield.textfield.size;
  }

  var align = fullWidth ? 'center' : 'stretch';

  var _source = source,
      fontSize = _source.fontSize,
      lineHeight = _source.lineHeight;


  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    align-items: ' + align + ';\n  ';
};

var slidingLabelOffset = function slidingLabelOffset(_ref2) {
  var slidingLabel = _ref2.slidingLabel,
      dense = _ref2.dense,
      fullWidth = _ref2.fullWidth,
      bordered = _ref2.bordered,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var textfieldStyleKey = bordered ? 'bordered' : 'underlined';
  var path = theme.reactackle.components.textfield.label.positionTop;
  var source = null;

  if (dense && !fullWidth) source = path.size[textfieldStyleKey].dense;else if (dense && fullWidth) source = path.size[textfieldStyleKey].denseFullWidth;else if (!dense && fullWidth) source = path.size[textfieldStyleKey].fullWidth;else source = path.size[textfieldStyleKey];

  var _source2 = source,
      labelSpacing = _source2.labelSpacing;
  var lineHeight = path.lineHeight;


  var paddingTop = 'calc(' + lineHeight + 'em + ' + (0, _reactackleCore.getValueString)(labelSpacing) + ')';

  return slidingLabel && 'padding-top: ' + paddingTop + ';';
};

/** STYLES */
var TextFieldRowStyled = exports.TextFieldRowStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TextFieldRowStyled'
})(['display:flex;position:relative;max-width:100%;flex-grow:1;', ';', ';'], size, slidingLabelOffset);

TextFieldRowStyled.propTypes = propTypes;
TextFieldRowStyled.defaultProps = defaultProps;
TextFieldRowStyled.displayName = 'TextFieldRowStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text-field/dist/styles/TextFieldRowStyled.js
// module id = 853
// module chunks = 0